import React from 'react';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';

import { StatusSelector } from '../../../features/process/components/status-selector';
import { AssigneeSelector } from '../../../components/assignee-selector/assignee-selector';
import { Tooltip } from '../../../components/tooltip/Tooltip';

import { Step, StepStatus } from '../../../app/entities/step';

import styles from './step-gantt-header.module.scss';
type StepGanttHeaderProps = {
  step: Step;
  isViewOnly?: boolean;
};

export const StepGanttHeader: React.FC<StepGanttHeaderProps> = observer(({ step, isViewOnly }) => {
  const navigate = useNavigate();
  const handleChangeStatus = async (newStatus: StepStatus) => {
    try {
      await step.update({ status: newStatus });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div
      className={styles['container']}
      id={`${step._id}-header`}
      onClick={() =>
        navigate(`/space/${step.project?.spaceId}/projects/${step.projectId}/steps/${step._id}`)
      }
      data-dim={step.done}
    >
      <div className={styles['title-container']}>
        <StatusSelector
          onChange={handleChangeStatus}
          statusMap={Step.StatusMapper}
          status={step.status}
          isViewOnly={isViewOnly}
        />

        <Tooltip text="Open step" position="top" delay={500}>
          <p className={styles['title']}>{step.displayName}</p>
        </Tooltip>
      </div>

      <div onClick={(e) => e.stopPropagation()}>
        <AssigneeSelector
          isViewOnly={isViewOnly}
          project={step.project!}
          selectedMemberId={step.assigneeId}
          onChange={(assigneeId) => step.update({ assigneeId })}
          iconOnly
        />
      </div>
    </div>
  );
});
